import BLOCKED_EXTENSIONS_LIST from "./blocked-extensions.json";

export const BLOCKED_EXTENSIONS = new Set(
  (BLOCKED_EXTENSIONS_LIST || []).map((x) => String(x).toLowerCase()),
);

export function getFileExtension(fileName) {
  if (!fileName) return "";
  const idx = fileName.lastIndexOf(".");
  if (idx <= 0 || idx === fileName.length - 1) return "";
  return fileName.slice(idx).toLowerCase();
}

export function isBlockedAttachment(fileName) {
  const ext = getFileExtension(fileName);
  return ext ? BLOCKED_EXTENSIONS.has(ext) : false;
}
